var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0L0.666748 0L0.666748 20L17.3334 20L17.3334 6.66667L10.6667 6.66667L10.6667 0ZM2.33341 1.66667L9.00008 1.66667V3.33333L2.33341 3.33333L2.33341 1.66667ZM9.00008 5L2.33341 5V6.66667L9.00008 6.66667L9.00008 5ZM12.3334 18.3333L10.6667 18.3333L7.33341 12.5L7.33341 18.3333H5.66675L5.66675 10L7.50981 10L10.6667 15.4167V10H12.3334L12.3334 18.3333ZM14.0001 3.33333L11.5001 0.833333L11.5001 5.83333L16.5001 5.83333L14.0001 3.33333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationIcon);
export default __webpack_public_path__ + "static/media/AnnotationIcon.95ecd6086c9d6929fb1acabdf5fcd5c3.svg";
export { ForwardRef as ReactComponent };